module KendoWidgets
{
	export class WindowOptions implements kendo.ui.WindowOptions
	{
		//#region Properties
		title?: string | boolean;
		showOkButton?: boolean;
		textOkButton?: string;
		showCancelButton?: boolean;
		textCancelButton?: string;
		visible?: boolean;
		isModal?: boolean;
		draggable?: boolean | kendo.ui.WindowDraggable;
		draggableElement?: HTMLElement;
		resizable?: boolean;
		height?: number | undefined | string;
		width?: number | undefined | string;
		maxHeight?: number;
		animation?: any;
		padding?: number | undefined;
		content?: string | kendo.ui.WindowContent;
		iframe?: boolean | undefined;
		pinned?: boolean;
		position?: kendo.ui.WindowPosition;
		maximized?: boolean;
		fullScreen?: boolean;
		fullScreenIframe?: boolean;
		footerCustomControls?: FooterControl[];

		saveWindow?(): void;
		closeWindow?(e?: WindowCloseEvent): void;
		isCloseable?: boolean;

		open?(e: kendo.ui.WindowEvent): void;
		refresh?(e: kendo.ui.WindowEvent): void;
		resize?(e: kendo.ui.WindowEvent): void;
		dragstart?(e: kendo.ui.WindowEvent): void;
		dragend?(e: kendo.ui.WindowEvent): void;
		activate?(e: kendo.ui.WindowEvent): void;
		//#endregion
	}

	export class Window extends kendo.ui.Window implements KendoWidget
	{
		private _height: number;
		private _width: number;
		private _childrenWindow: Window[];

		public controlType(): ControlTypeEnum { return ControlTypeEnum.Window; }

		constructor(element: Element, options: KendoWidgets.WindowOptions)
		{
			if (options == null)
				options = new KendoWidgets.WindowOptions();

			//#region Default options
			if (options.visible == null) options.visible = false;
			if (options.showOkButton == null) options.showOkButton = true;
			if (options.textOkButton == null) options.textOkButton = "Salva";
			if (options.showCancelButton == null) options.showCancelButton = true;
			if (options.textCancelButton == null) options.textCancelButton = "Chiudi";
			if (options.resizable == null) options.resizable = false;
			if (options.width == null) options.width = "auto";
			if (options.padding == null) options.padding = 10;
			if (options.draggable == null) options.draggable = true;
			if (options.iframe == null) options.iframe = false;
			if (options.isCloseable == null) options.isCloseable = true;
			options.animation = false;
			if (options.isModal == null) options.isModal = true;
			if (options.fullScreen == null) options.fullScreen = false;
			if (options.title == null) options.title = "";
			if (options.fullScreenIframe == null) options.fullScreenIframe = true;

			if (!options.isCloseable)
				options.showCancelButton = false;
			//#endregion

			//#region Close
			let closeUserOverride = options.closeWindow;
			options.closeWindow = () =>
			{
				that.removeBackground();

				if (closeUserOverride != null)
					closeUserOverride();
			};
			//#endregion	

			//#region Drag
			let dragStartUserOverride = options.dragstart;
			options.dragstart = function (e: kendo.ui.WindowEvent)
			{
				window.setTimeout(() => $(".k-overlay").remove(), 100);

				if (dragStartUserOverride != null)
					dragStartUserOverride(e);
			};
			//#endregion

			//#region Maximized
			if (options.maximized == true)
			{
				if (options.fullScreen)
				{
					options.width = "100%";
					options.height = "100%";
				}
				else
				{
					let difference = 30;
					options.width = (options.width === "auto") ? (document.body.clientWidth - 30) : options.width;
					options.height = (options.height == null) ? document.body.clientHeight - difference : options.height;
				}
			}
			//#endregion

			super(element, options);
			$(element.parentElement!).addClass("vrContainer");

			if (options.maximized == true)
				$(element.parentElement!).css("height", options.height!);

			if (options.position == null)
				this.center();

			let that = this;

			//#region Drag
			if (options.draggableElement != null)
				that.draggable(options.draggableElement);
			//#endregion

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region Padding
			(element as HTMLElement).style.cssText += "padding: " + options.padding + "px";
			//#endregion
			//#region X to close			if (options.isCloseable)
			{
				$("#" + element.id + "XButton").remove();
				let button = document.createElement("button");
				button.id = element.id + "XButton";
				button.classList.add("closeWindowButton");
				$(button).kendoButton(<KendoWidgets.ButtonOptions>
					{						icon: "close",
						css: "margin-right: -18px; background: none; border: none; color: #FFF; margin-top: -2px !important;",
						click: (e) =>
						{
							that.close();
						}
					});				$(this.window()).find(".k-header").append(button);			}			//#endregion			this._height = this.element.height();			this._width = this.element.width();			this._childrenWindow = [];		}

		addChildrenWindow(window: Window)
		{
			this._childrenWindow.push(window);
		}

		open(callbackSave?: () => void, callbackClose?: (e: WindowCloseEvent) => void)
		{
			let that = this;
			super.open();
			if (this.options.position == null)
				this.center();

			let zIndex = parseFloat(this.element.parent().css("z-index"));
			zIndex -= 1;

			if ((this.options as KendoWidgets.WindowOptions).isModal)
			{
				// Background
				$("#" + this.element.attr("id") + "Background").remove();
				let background: HTMLDivElement = document.createElement("div");
				background.id = this.element.attr("id") + "Background";
				background.setAttribute("style", "position: fixed; left: 0px; top: 0px; z-index: " + zIndex + "; background-color: #CCC; opacity: 0.5; width: 100%; height: 100%;");
				background.onclick = () =>
				{
					if ((this.options as KendoWidgets.WindowOptions).isCloseable)
						that.close();
				};
				$(background).appendTo(document.body);
			}

			//#region Callback
			if (callbackSave != null)
				(this.options as KendoWidgets.WindowOptions).saveWindow = callbackSave;

			if (callbackClose != null)
				(this.options as KendoWidgets.WindowOptions).closeWindow = callbackClose;
			//#endregion

			//#region Footer
			if (((this.options as KendoWidgets.WindowOptions).showOkButton
				|| (this.options as KendoWidgets.WindowOptions).showCancelButton
				|| (this.options as KendoWidgets.WindowOptions).footerCustomControls != null)
				&& $("#" + this.element[0].id + "Footer")[0] == null)
			{
				// If fixed height
				let extraStyleDivFooter = "";
				if ((this.options as KendoWidgets.WindowOptions).height != null)
				{
					let h: string | number = (this.options as KendoWidgets.WindowOptions).height!;
					if (typeof ((this.options as KendoWidgets.WindowOptions).width) == "number")
						h = String((this.options as KendoWidgets.WindowOptions).height).getNumericPart() - 62;
					else
						h = "Calc(" + String((this.options as KendoWidgets.WindowOptions).height).getNumericPart() + "% - 62px)";

					if ((this.options as KendoWidgets.WindowOptions).iframe && (this.options as KendoWidgets.WindowOptions).fullScreenIframe == true)
						this.element[0].parentElement!.style.cssText += "height: 100% !important";

					$(this.element).height(h);
					extraStyleDivFooter = "position: absolute; bottom: 6px; left: 0px; margin-bottom: 0px !important;";
				}

				// Create div footer
				let footerId = this.element[0].id + "Footer";
				let divFooter = document.createElement("div");
				divFooter.id = footerId;
				divFooter.classList.add("vrKendoWindowDivFooter");
				divFooter.style.cssText += extraStyleDivFooter + "width: Calc(100% - 20px); margin-top: 10px; margin-bottom: 5px; border-top: solid 1px #CCC; padding-top: 5px; text-align: right; padding-right: 10px; padding-left: 10px;";
				this.window().appendChild(divFooter);

				//#region Custom footer controls
				if ((this.options as KendoWidgets.WindowOptions).footerCustomControls != null)
				{
					for (let customControl of (this.options as KendoWidgets.WindowOptions).footerCustomControls!)
					{
						if (customControl.align == null) customControl.align == FooterButtonAlignEnum.Right;
						if (customControl.type == null) customControl.type = FooterControlTypeEnum.Button;

						if (customControl.type == FooterControlTypeEnum.Button)
						{
							let btnFooterCustomButton = document.createElement("button");
							btnFooterCustomButton.id = (customControl.value != null) ? customControl.value : "";
							btnFooterCustomButton.textContent = (customControl.text != null) ? customControl.text : "";
							divFooter.appendChild(btnFooterCustomButton);
							$(btnFooterCustomButton).kendoButton(
								{
									icon: customControl.icon,
									iconPosition: customControl.iconPosition,
									imageUrl: customControl.imageUrl,
									css: "margin-right: 5px;" + ((customControl.align == FooterButtonAlignEnum.Left) ? "float: left;" : ""),
									textColor: customControl.textColor,
									backgroundColor: customControl.backgroundColor,
									isPrimaryButton: customControl.isPrimaryButton,
									isDeleteButton: customControl.isDeleteButton,
									tooltip: customControl.tooltip,
									confirmationMessage: customControl.confirmationMessage,
									visible: customControl.visible,
									enable: customControl.enabled,
									class: customControl.cssClass,
									singleClickTimeout: 0,
									click: function (e: kendo.ui.ButtonClickEvent)
									{
										let footerButtonClickEvent = new FooterButtonClickEvent();
										footerButtonClickEvent.sender = that;
										if (customControl.click != null)
											customControl.click(footerButtonClickEvent);
									}
								});
						}
						else if (customControl.type == FooterControlTypeEnum.SplitButton)
						{
							let text = (customControl.text != null) ? customControl.text : "";

							let divSplitButton = document.createElement("div");
							divSplitButton.id = (customControl.value != null) ? customControl.value : "";
							divFooter.appendChild(divSplitButton);
							$(divSplitButton).kendoSplitButton(
								{
									text: text,
									items: customControl.splitButtonItems!,
									icon: customControl.icon,
									visible: customControl.visible,
									css: "margin-right: 5px;" + ((customControl.align == FooterButtonAlignEnum.Left) ? "float: left;" : ""),
									isPrimaryButton: customControl.isPrimaryButton,
									click: function (e: KendoWidgets.SplitButtonClickEvent)
									{
										let footerButtonClickEvent = new FooterButtonClickEvent();
										footerButtonClickEvent.sender = that;
										if (customControl.click != null)
											customControl.click(footerButtonClickEvent);
									}
								});
						}
					}
				}
				//#endregion

				//#region Save button
				if ((this.options as KendoWidgets.WindowOptions).showOkButton)
				{
					let btnFooterSaveButton = document.createElement("button");
					btnFooterSaveButton.innerHTML = DOMPurify.sanitize((this.options as KendoWidgets.WindowOptions).textOkButton!);
					btnFooterSaveButton.classList.add("vrKendoPrimaryButton", "wndSaveButton");
					divFooter.appendChild(btnFooterSaveButton);
					$(btnFooterSaveButton).kendoButton(
						{
							click: function (e: kendo.ui.ButtonClickEvent)
							{
								if ((that.options as KendoWidgets.WindowOptions).saveWindow != null)
									(that.options as KendoWidgets.WindowOptions).saveWindow!();
							}
						});
				}
				//#endregion

				//#region Cancel button
				if ((this.options as KendoWidgets.WindowOptions).showCancelButton)
				{
					let btnFooterCancelButton = document.createElement("button");
					btnFooterCancelButton.innerHTML = DOMPurify.sanitize((this.options as KendoWidgets.WindowOptions).textCancelButton!);
					btnFooterCancelButton.classList.add("wndCancelButton");
					divFooter.appendChild(btnFooterCancelButton);
					$(btnFooterCancelButton).kendoButton(
						{
							click: function (e: kendo.ui.ButtonClickEvent)
							{
								that.close();
							}
						});
				}
				//#endregion				
			}

			//#endregion

			return this;
		}

		private removeBackground()
		{
			let background = $("#" + this.element.attr("id") + "Background");
			if (background != null)
				$(background).remove();
		}

		draggable(elementOrState: boolean | HTMLElement | string): any
		{
			if (typeof (elementOrState) == "boolean")
				this.setOptions({ draggable: elementOrState });
			else
			{
				$(elementOrState).mousedown((emd: JQueryMouseEventObject) =>
				{
					let startingXPosition = emd.clientX;
					let startingYPosition = emd.clientY;

					// Moving
					$(document).mousemove((emm: JQueryMouseEventObject) => 
					{
						if (!(emm.clientX == startingXPosition && emm.clientY == startingYPosition))
							$(this.element.closest(".k-window")[0]).offset({ top: emm.clientY, left: (emm.clientX - (this.element.width() / 2)) });
					});

					// Stop moving
					$(document).mouseup(() =>
					{
						$(document).unbind("mouseup");
						$(document).unbind("mousemove");
					});
				});
			}
		}

		close(e?: WindowCloseEvent)
		{
			let closeEvent = (e != null) ? e : new WindowCloseEvent();

			if (closeEvent["isDefaultPrevented"] == null)
				closeEvent = new WindowCloseEvent()

			if ((this.options as KendoWidgets.WindowOptions).closeWindow != null)
				(this.options as KendoWidgets.WindowOptions).closeWindow!(closeEvent);

			if (closeEvent.isDefaultPrevented())
				return this;

			//#region Children window
			if (this._childrenWindow != null && this._childrenWindow.length > 0)
			{
				for (let childrenWindow of this._childrenWindow)
					childrenWindow.close();

				this._childrenWindow = [];
			}
			//#endregion

			this.removeBackground();
			this.element.parent().hide();
			return this;
		}

		save()
		{
			if ((this.options as KendoWidgets.WindowOptions).saveWindow != null)
				(this.options as KendoWidgets.WindowOptions).saveWindow!();
		}

		height(height?: number)
		{
			if (height != null)
			{
				this._height = height;

				if ((this.options as KendoWidgets.WindowOptions).showOkButton || (this.options as KendoWidgets.WindowOptions).showCancelButton)
				{
					this.element.height(height - 62);
					this.element.parent().find(".vrKendoWindowDivFooter")[0].style.cssText += "margin-top: 0px";
				}
				else
					this.element.height(height);

				this.element.parent().height(height);
				this.center();
			}

			return this._height;
		}

		width(width?: number)
		{
			if (width != null)
			{
				this._width = width;
				this.element.parent().width(width);
				this.center();
			}

			return this._width;
		}

		size(width: number, height: number)
		{
			//#region Height
			this._height = height;
			if ((this.options as KendoWidgets.WindowOptions).showOkButton || (this.options as KendoWidgets.WindowOptions).showCancelButton)
			{
				this.element.height(height - 62);
				this.element.parent().find(".vrKendoWindowDivFooter")[0].style.cssText += "margin-top: 0px";
			}
			else
				this.element.height(height);

			this.element.parent().height(height);
			//#endregion

			//#region Width
			this._width = width;
			this.element.parent().width(width);
			this.element.width(width - 20);
			//#endregion

			this.center();
		}

		window()
		{
			return this.element.closest(".k-window")[0];
		}

		position(position?: KendoWidgets.WindowPosition)
		{
			if (position != null)
			{
				this.setOptions(
					{
						position:
						{
							top: position.top,
							left: position.left
						}
					});
			}
			return this.options.position as KendoWidgets.WindowPosition;
		}

		textOkButton(text?: string)
		{
			let saveButton = $("#" + this.element[0].id + "Footer").find(".wndSaveButton").data("kendoButton") as KendoWidgets.Button;
			if (saveButton != null && text != null)
				saveButton.text(text);

			return saveButton.text();
		}

		textCancelButton(text?: string)
		{
			let cancelButton = $("#" + this.element[0].id + "Footer").find(".wndCancelButton").data("kendoButton") as KendoWidgets.Button;
			if (cancelButton != null && text != null)
				cancelButton.text(text);

			return cancelButton.text();
		}

		okButton()
		{
			let saveButton = $("#" + this.element[0].id + "Footer").find(".wndSaveButton").data("kendoButton") as KendoWidgets.Button;
			return saveButton;
		}

		cancelButton()
		{
			let cancelButton = $("#" + this.element[0].id + "Footer").find(".wndCancelButton").data("kendoButton") as KendoWidgets.Button;
			return cancelButton;
		}

		footerControl<T extends KendoWidgets.Button | KendoWidgets.SplitButton>(value: string, footerControlTypeEnum?: FooterControlTypeEnum): T
		{
			if (!value.startsWith("#"))
				value = "#" + value;

			if (footerControlTypeEnum == null)
				return $("#" + this.element[0].id + "Footer").find(value).data("kendoButton") as T;
			else
			{
				switch (footerControlTypeEnum)
				{
					case FooterControlTypeEnum.SplitButton: return $("#" + this.element[0].id + "Footer").find(value).data("kendoSplitButton") as T;
					default:
						return $("#" + this.element[0].id + "Footer").find(value).data("kendoButton") as T;
				}
			}
		}

		customButton(value: string)
		{
			return this.footerControl<KendoWidgets.Button>(value, FooterControlTypeEnum.Button);
		}
	}

	Window.fn = Window.prototype;
	Window.fn.options = $.extend(true, {}, kendo.ui.Window.fn.options);
	Window.fn.options.name = "Window";
	kendo.ui.plugin(Window);

	export class WindowPosition
	{
		top: number;
		left: number;
	}

	export class FooterControl
	{
		type?: FooterControlTypeEnum;
		text?: string;
		icon?: string;
		iconPosition?: IconPositionEnum;
		imageUrl?: string;
		value?: string;
		textColor?: ColorEnum | string;
		backgroundColor?: ColorEnum | string;
		isPrimaryButton?: boolean;
		isDeleteButton?: boolean;
		tooltip?: string;
		confirmationMessage?: string;
		align?: FooterButtonAlignEnum;
		visible?: boolean;
		enabled?: boolean;
		cssClass?: string;
		splitButtonItems?: SplitButtonItem[];

		click?(e: FooterButtonClickEvent): void;
	}

	export enum FooterControlTypeEnum
	{
		Button,
		SplitButton
	}

	class FooterButtonClickEvent
	{
		sender: KendoWidgets.Window;
	}

	export enum FooterButtonAlignEnum
	{
		Left,
		Right
	}

	export class WindowCloseEvent
	{
		private _isDefaultPrevented: boolean;

		preventDefault()
		{
			this._isDefaultPrevented = true;
		}

		enableDefault()
		{
			this._isDefaultPrevented = false;
		}

		isDefaultPrevented()
		{
			return this._isDefaultPrevented;
		}
	}
}

interface JQuery
{
	kendoWindow(options: KendoWidgets.WindowOptions): JQuery;
}